/**
 * Query keys do dominio announcements / comunicados (apps/crm).
 *
 * `club_announcements` (C6 status + C7 vigencia) + `club_announcement_attachments`
 * (C8). Lista aceita filtros opcionais (status, ativosHoje) — eles entram na key
 * para invalidar corretamente quando o usuario muda o filtro.
 */
import { tuple } from "./core";

const root = ["announcements"] as const;

export type AnnouncementStatusFilter = "all" | "draft" | "published" | "archived";

export interface AnnouncementListFilters {
  status?: AnnouncementStatusFilter;
  /** Quando true, filtra valid_from <= hoje AND (valid_until IS NULL OR valid_until >= hoje). */
  activeToday?: boolean;
}

export const announcements = {
  all: root,
  /** Lista de anuncios de um clube, com filtros opcionais. */
  list: (
    clubId: string | null | undefined,
    filters?: AnnouncementListFilters,
  ) => tuple(root, "list", clubId, filters ?? {}),
  byId: (announcementId: string | null | undefined) =>
    tuple(root, "detail", announcementId),
  /** Anexos de um anuncio (`club_announcement_attachments`). */
  attachments: (announcementId: string | null | undefined) =>
    tuple(root, "attachments", announcementId),
} as const;
